// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseAvatar_wrapper_25bG0","avatar":"BaseAvatar_avatar_3jK-m","hoverOverlayWrapper":"BaseAvatar_hoverOverlayWrapper_3mqBv"};